<template>
<div class="chapter">
<div class="inner_page">
<div id="Prologue.html" xml:lang="en-US">
<div class="Basic-Text-Frame-22">
<p class="ch"><a id="Anchor-1">Prologue</a></p><a id="Anchor-1">
<p class="body-text-opening">Seven. Most people thought the number was lucky. <em class="italic">He’d </em>even thought it had been lucky. This was supposed to be his seventh trip, the last run of the season, the last cleanup before he could head to Mexico and lie on the beach for the winter. Señoritas, sunshine, cervezas...everything he needed to be happy.</p>
<p class="body-text">Yet now as he stared down the predator, he could have sworn seven was a curse.</p>
<p class="body-text">The grizzly hopped on its front legs like a dog ready to play, but from what little he knew about bears, it wasn’t an action that meant fun and games...no, that was an action that meant danger.</p>
<p class="body-text">He eased back a step as he held the bear’s gaze. Its beady black eyes bore into him, sizing him up.</p>
<p class="body-text">Not for the first time in his life, he wished he were eight feet tall.</p>
<p class="body-text">“Good bear,” he said, putting his hands up. “Good bear.” He turned to look over his shoulder, but the man he’d been sent there to meet was gone. “Damn him.”</p>
<p class="body-text">Without warning, the bear charged. The fur on its shoulders rippled, its gold tips harsh against the white snow. He screamed, the sound echoing through the high mountain valley.</p>
<p class="body-text">The beast didn’t slow down.</p>
<p class="body-text">He turned to run, but it was too late. The griz hit him like no force he had ever experienced. Its putrid, hot breath seared the back of his neck as he fell to the ground. Heat and pain spread through his body as the predator’s teeth met bone.</p>
<p class="body-text">He closed his eyes, pain burning through him as the gunshot rang out.</p>
<p class="body-text">The world, the pain, the fear—everything stopped.</p>
<p class="Basic-Paragraph-16">
</p></a></div><a id="Anchor-1">
</a></div><a id="Anchor-1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Prologue.vue?43637766